import React, { useEffect, useState } from "react";
import Breadcrumbs from "common/Breadcrumbs/Breadcrumbs";
import { P } from "common/P/P";
import { routeConstants } from "navigation/routeConstants";
import { Button } from "common/Button/Button";
import { ReactComponent as AddLetterIcon } from "common/assets/icons/add-page.svg";
import Pagination from "components/Pagination/Pagination";
import OrdersTable from "components/OrderTable/OrdersTable";
import Modal from "common/Modal/Modal";
import { Select } from "common/Select/Select";
import { SelectItem } from "common/Select/SelectItem";
import DatePicker from "common/DatePicker/DatePicker";
import { Input } from "common/Input/Input";
import FileUpload from "common/FileUpload/FileUpload";
import { serviceConfig } from "configs";
import axios from "axios";
import IGHTable from "components/IGHTable/IGHTable";
import { ReactComponent as LangIcon } from "common/assets/flags/tk.svg";
import { ReactComponent as ThemeIcon } from "common/assets/icons/moon-stars.svg";
import { ReactComponent as NotificationIcon } from "common/assets/icons/bell.svg";
import { ReactComponent as AvatarIcon } from "common/assets/icons/user.svg";
import { SearchInput } from "common/Search/Search";

const breadcrumbItems = [
	{ label: "Içerki resminamalar", path: routeConstants.root.route },
	{ label: "Iberenler" },
];

const InternalSendingPage: React.FC = (): JSX.Element => {
	const userString = localStorage.getItem("user");
	const user = userString ? JSON.parse(userString) : null;

	const userId = user ? user?.user?._id : null; // Replace with actual user ID
	const userTypeId = user ? user?.user.userTypeId?._id : null;
	const numericUserTypeId = parseInt(userTypeId);
	const [currentPage, setCurrentPage] = useState(1);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [iihLetters, setiihLetters] = useState([]);
	const [recentiihLetters, setRecentiihLetters] = useState<any>([]);
	const [iihLettersByStatus, setiihLettersByStatus] = useState<any>([]);
	const [currentView, setCurrentView] = useState("all");
	const [totalPages, setTotalPages] = useState(0);
	const [selectedUserLabel, setSelectedUserLabel] = useState<any>("");
	const [sendTargets, setSendTargets] = useState<any>([]);
	const [searchValue, setSearchValue] = useState("");

	const openModal = () => setIsModalOpen(true);
	const closeModal = () => setIsModalOpen(false);

	useEffect(() => {
		const fetchSendTargets = async () => {
			try {
				const response = await fetch(
					`${serviceConfig.apiUrl}/iih/send-targets/${userTypeId}`
				);
				const data = await response.json();
				setSendTargets(data.data); // Update with your actual data structure
			} catch (error) {
				console.error("Error fetching send targets:", error);
			}
		};
		fetchSendTargets();
	}, []);

	const itemsPerPage = 10;

	const fetchiihLetters = async () => {
		try {
			const response = await axios.get(`${serviceConfig.apiUrl}/iih/${userId}`);
			setiihLetters(response.data.data);
			setTotalPages(Math.ceil(response.data.data.length / itemsPerPage));
		} catch (error) {
			console.error("Error fetching iih letters:", error);
		}
	};

	// Fetch Recent iih letters
	const fetchRecentiihLetters = async () => {
		try {
			const response = await axios.get(
				`${serviceConfig.apiUrl}/iih-new/${userId}`
			);
			setRecentiihLetters(response.data.data);
		} catch (error) {
			console.error("Error fetching recent iih letters:", error);
		}
	};

	// Fetch iih letters by status
	const fetchiihLettersByStatus = async () => {
		try {
			const response = await axios.get(
				`${serviceConfig.apiUrl}/iih-status/${userId}`
			);
			setiihLettersByStatus(response.data.data);
		} catch (error) {
			console.error("Error fetching iih letters by status:", error);
		}
	};

	useEffect(() => {
		fetchiihLetters();
		fetchRecentiihLetters();
		fetchiihLettersByStatus();
	}, []);

	const handleTabChange = (view: any) => {
		setCurrentView(view);
		switch (view) {
			case "all":
				setTotalPages(Math.ceil(iihLetters.length / itemsPerPage));
				break;
			case "recent":
				setTotalPages(Math.ceil(recentiihLetters.length / itemsPerPage));
				break;
			case "status":
				setTotalPages(Math.ceil(iihLettersByStatus.length / itemsPerPage));
				break;
			default:
				break;
		}
	};

	const getDataLength = () => {
		switch (currentView) {
			case "all":
				return iihLetters.length;
			case "recent":
				return recentiihLetters.length;
			case "status":
				return iihLettersByStatus.length;
			default:
				return 0;
		}
	};

	// Function to determine which data to display
	const getCurrentData = () => {
		let data;
		switch (currentView) {
			case "all":
				data = iihLetters;
				break;
			case "recent":
				data = recentiihLetters;
				break;
			case "status":
				// Extracting the 'letterId' details for 'recent' and 'status' tabs
				data = iihLettersByStatus;
				break;
			default:
				data = [];
		}
		return data.slice(
			(currentPage - 1) * itemsPerPage,
			currentPage * itemsPerPage
		);
	};

	const currentOrders = getCurrentData();

	const handleRowClick = (order: any) => {
		console.log("OPENED");
		// navigate(`/account/orders/${order._id}`);
	};

	const [formData, setFormData] = useState<any>({
		sentDate: "", // Format these dates as 'YYYY-MM-DD'
		deadlineDate: "",
		note: "",
		files: [], // This will hold file data,
		currentUserId: userId,
		sendingUserId: "",
	});

	const handleInputChange = (e: any) => {
		const { name, value, type, checked } = e.target;

		if (type === "radio" && checked) {
			setFormData((prevState: any) => ({ ...prevState, [name]: value }));
		} else if (type !== "radio") {
			setFormData((prevState: any) => ({ ...prevState, [name]: value }));
		}
	};

	const handleSelect = (userId: string) => {
		setFormData((prevState: any) => ({
			...prevState,
			sendingUserId: userId,
		}));
		const selectedUser = sendTargets.find((user: any) => user._id === userId);
		if (selectedUser) {
			setSelectedUserLabel(`${selectedUser.name} ${selectedUser.sirname}`);
		}
	};

	const handleFileChange = (e: any) => {
		if (e.target.files) {
			const filesArray = Array.from(e.target.files);
			setFormData((prevState: any) => ({
				...prevState,
				files: filesArray,
			}));
		}
	};

	// Update this function to handle date picker changes
	const handleDateChange = (name: string, date: string) => {
		setFormData((prevState: any) => ({ ...prevState, [name]: date }));
	};

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();

		const data = new FormData();
		Object.keys(formData).forEach((key) => {
			if (key === "files") {
				formData[key].forEach((file: File) => {
					data.append("files", file);
				});
			} else {
				if (key === "tags") {
					data.append(key, JSON.stringify(formData[key]));
				} else {
					data.append(key, formData[key]);
				}
			}
		});

		try {
			const response = await axios.post(`${serviceConfig.apiUrl}/iih`, data, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});
			setFormData({
				sentDate: "", // Format these dates as 'YYYY-MM-DD'
				deadlineDate: "",
				note: "",
				files: [], // This will hold file data,
				currentUserId: userId,
				sendingUserId: "",
			});
			closeModal();
			window.location.reload();
		} catch (error) {
			console.error("Error submitting form:", error);
		}
	};

	const handleSearchChange = async (e: any) => {
		const value = e.target.value;
		setSearchValue(value); // Update the searchValue state

		try {
			if (value.trim() === "") {
				// Reset to default data if search input is cleared
				fetchiihLetters();
			} else {
				// Perform the search with the specified fields
				const response = await axios.get(`${serviceConfig.apiUrl}/igh/search`, {
					params: { query: value },
				});
				setiihLetters(response.data.data);
				setTotalPages(Math.ceil(response.data.data.length / itemsPerPage));
			}
		} catch (error) {
			console.error("Error during search:", error);
		}
	};
	return (
		<div className="grid grid-cols-1 gap-4">
			<div className="grid grid-cols-1 gap-4 px-6 py-3 place-items-end">
				{/* <LangIcon />
					<ThemeIcon />
					<div className="relative">
						<NotificationIcon />
						<div className="absolute top-[-5px] right-[-5px] grid px-[0.4rem] py-[0.1rem] rounded-full place-items-center place-content-center bg-redColor">
							<P size="t2" type="semibold" className="text-white">
								4
							</P>
						</div>
					</div> */}
				<div className="grid gap-3 grid-cols-maxTwo place-items-center">
					<div className="p-2 rounded-full bg-grayOne">
						<AvatarIcon />
					</div>
					<div className="grid">
						<P size="t1" type="medium">
							{user ? `${user.user.name.charAt(0)}.${user.user.sirname}` : ""}
						</P>
						<P size="t2" type="regular" className="text-grayTwo">
							{user ? user.user.userTypeId?.positionName : ""}
						</P>
					</div>
				</div>
			</div>
			<div className="grid grid-flow-row auto-rows-max pb-7 gap-6 px-6 min-h-[90vh]">
				<Breadcrumbs items={breadcrumbItems} />
				<div className="grid grid-cols-maxTwo place-content-between place-items-center">
					<div className="grid gap-4 grid-cols-maxTwo">
						<div className="grid grid-cols-maxThree h-max">
							<div
								className={`min-w-[88px] text-center px-4 py-2 ${
									currentView === "all"
										? "border rounded-l-md border-mainColor bg-mainGradient"
										: "border rounded-l-md border-mainColor bg-white"
								} cursor-pointer`}
								onClick={() => handleTabChange("all")}
							>
								<P
									size="p3"
									type="medium"
									className={`${
										currentView === "all" ? "text-white" : "text-mainColor"
									} cursor-pointer`}
								>
									Hemmesi ({iihLetters.length})
								</P>
							</div>
							<div
								className={`min-w-[88px] text-center px-4 py-2 ${
									currentView === "recent"
										? "bg-mainGradient border-y border-mainColor"
										: "bg-white border-y border-mainColor"
								}  cursor-pointer`}
								onClick={() => handleTabChange("recent")}
							>
								<P
									size="p3"
									type="medium"
									className={`cursor-pointer ${
										currentView === "recent" ? "text-white" : "text-mainColor"
									} `}
								>
									Täze
								</P>
							</div>
							<div
								className={`min-w-[88px] text-center px-4 py-2 ${
									currentView === "status"
										? "bg-mainGradient border rounded-r-md border-mainColor"
										: "bg-white border rounded-r-md border-mainColor"
								} cursor-pointer`}
								onClick={() => handleTabChange("status")}
							>
								<P
									size="p3"
									type="medium"
									className={`cursor-pointer ${
										currentView === "status" ? "text-white" : "text-mainColor"
									}`}
								>
									Talap edildi
								</P>
							</div>
						</div>
						<SearchInput
							placeholder="Gözle"
							value={searchValue}
							onChange={handleSearchChange}
						/>
					</div>
					{numericUserTypeId === 1 && (
						<Button
							appearance="main"
							paddingY="py-2"
							className="h-max"
							icon={<AddLetterIcon />}
							onClick={openModal}
						>
							Haty ibermek
						</Button>
					)}
				</div>
				<Modal
					isOpen={isModalOpen}
					onClose={closeModal}
					title="Çykýan/Gidýän hat"
					width="w-[600px]"
				>
					<div className="grid grid-flow-row grid-cols-1 gap-6 auto-rows-max">
						<div className="grid grid-cols-1">
							<Select
								label="Kabul ediji"
								onSelect={handleSelect}
								defaultSelectLabel="Kabul ediji"
								value={selectedUserLabel} // Display the selected user's name and surname
							>
								{sendTargets.map((user: any) => (
									<SelectItem key={user._id} value={user._id}>
										{user.name} {user.sirname}
									</SelectItem>
								))}
							</Select>
						</div>

						<div className="grid grid-cols-1 gap-4 place-items-center">
							<DatePicker
								label="Senesi"
								onDateChange={(sentDate) =>
									handleDateChange("sentDate", sentDate)
								}
							/>
						</div>
						<div className="grid grid-cols-1 gap-4 place-items-center">
							<DatePicker
								label="Ýerine ýetirilmeli soňky senesi"
								onDateChange={(date) => handleDateChange("deadlineDate", date)}
							/>
						</div>
						<Input
							appearance="default"
							type="text"
							name="note"
							withlabel={true}
							label="Gysgaça beýany"
							value={formData.note}
							onChange={handleInputChange}
						/>

						<div className="grid grid-cols-1">
							<FileUpload files={formData.files} onChange={handleFileChange} />
						</div>

						<Button
							appearance="main"
							className="place-self-end"
							paddingX="px-5"
							paddingY="py-[10px]"
							onClick={handleSubmit}
						>
							Ibermek
						</Button>
					</div>
				</Modal>
				<div>
					<IGHTable
						orders={currentOrders}
						onRowClick={handleRowClick}
						type="iih"
					/>
					<div className="grid grid-cols-maxTwo place-content-between place-items-center py-[14px] px-[20px] border-x border-b border-strokeColor rounded-b-md">
						<P size="t2" type="regular" className="text-grayTwo">
							Jemi {getDataLength()} sany
						</P>
						<Pagination
							currentPage={currentPage}
							totalPages={totalPages}
							onPageChange={setCurrentPage}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default InternalSendingPage;
